<script lang="ts">
    
    import { onMount } from "svelte";
    import { navigate, useLocation } from "svelte-navigator";
    import type { Game } from "../../Model/Game";
    import { boardsService, gamesService, hasBoard, playerService, room, roomsService } from "../../Services";
    import { isCardsBingoGame } from "../../Services/aux";
    import { i18n } from "../../Services/i18n";
    import GetBoardForm from "../Board/GetBoardForm.svelte";
    import GameMetaInfo from "../Game/GameMetaInfo.svelte";
    import PlayerForm from "../Player/PlayerForm.svelte";
    import TopBar from "../Shared/TopBar.svelte";
    import Watch from "../Shared/Watch.svelte";
    import RoomBar from "./RoomBar.svelte";
    import RoomTransit from "./RoomTransit.svelte";
    import { reload } from "../../Services/ReloadService";

    const location = useLocation();

    let game: Game;
    let showMessage: boolean = false;
    let loading: boolean = true;
    let reloading = false;
    let gameCode = null;

    $: reload.subscribe(value => reloading = value);

    onMount(init);

    async function init(): Promise<void> {
        game = await roomsService.getCurrentGameInRoom($room.id);
        
        if (!$location.search) {
            $hasBoard = !!(await boardsService.getBoard(game.id));
            return;
        }

        const query = new URLSearchParams($location.search);
        if (query.has('gameCode')) {
            if(await gamesService.checkIfCodeIsInUse(query.get('gameCode'))){
                gameCode = query.get('gameCode');
            } else {
                gameCode = '';
            }
        
            try {
                await verfGameCode();
                if(showMessage && !$hasBoard) {
                    await boardsService.createBoard(game.id, gameCode);
                }
            } catch (error) {
                verfGameCode();
                console.log(error);
                $hasBoard = false;
            }
        }
    }

    function verfGameCode() {
        loading = false;
        const query = new URLSearchParams($location.search);
        if (query.has('gameCode') && query.get('gameCode') == game.code) {
            showMessage = true;
        } else {
            showMessage = false;
        }
    }

    function onBoardCreated(): void {
        $hasBoard = true;
        showMessage = true;
        const url = new URL(window.location.origin + $location.pathname);
        url.searchParams.set('gameCode', game.code)
        navigate(url.href)
    }

</script>

<div class="waiting-room">

    <TopBar />
    
    {#if isCardsBingoGame(game?.type)}'
        <RoomBar>
            {#if $hasBoard}
                <GameMetaInfo {game} />
            {/if}
        </RoomBar>
    {/if}

    <div class="content">
        <Watch state={playerService.isRegistered} let:value={isRegistered}>
            {#if isRegistered}
                {#if loading}
                    <span>Loading...</span>
                {:else}
                    <!-- {#if game}
                        <GameCountdown {game} />
                    {/if}-->
                    <!-- <h3>{$i18n('El juego comenzará pronto')}</h3> -->
                    {#if showMessage}
                        <h3>{$i18n('El juego comenzará pronto')}</h3>
                    {:else}
                        <GetBoardForm gameId={game?.id}  bind:gameCode={gameCode} on:submited={() => onBoardCreated()} />
                    {/if}
                {/if}
            {:else}
                <PlayerForm roomId={$room.id} />
            {/if}
        </Watch>
    
        <!-- {#if game && $hasBoard === false}
            <div class="board-form-container">
                <GetBoardForm gameId={game.id} on:boardcreated={onBoardCreated} />
            </div>
        {/if} -->
    </div>

</div>

<div class="room-transit">
    <RoomTransit roomId={$room.id} />
</div>

<!-- {#if reloading}
    <div class='banner bg-danger p-4 rounded w-75 d-flex gap-4 align-items-center'>
        <span>It seems you have lost connection. Please, reload the page.</span>
    </div>
{/if} -->
<style lang="scss">

    .waiting-room {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
    }

    .content {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .room-transit {
        padding: 1rem;
    }

    .board-form-container {
        width: calc(100% - 2rem);
    }

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }

</style>